import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate, createSearchParams, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import _ from 'lodash';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Spinner,
  UncontrolledTooltip,
  TabPane,
  CardFooter,
} from 'reactstrap';
import PageTabs from 'components/PageTabs';
import Details from './tabs/Details';
import Summary from './tabs/Summary';
import ShortTermReturns from './tabs/ShortTermReturns';
import LongTermReturns from './tabs/LongTermReturns';
import CalendarYearReturns from './tabs/CalendarYearReturns';
import RiskMetrics from './tabs/RiskMetrics';
import AssetSelect from '../AssetSelect';
import ToggleContainer from 'components/ToggleContainer';

function QuickView({ session }) {
  const [params, setParams] = useState(null);
  const [name, setName] = useState('');

  const sideMenu = (
    <AssetSelect
      session={session}
      onSelect={({ product, database, converter }) => {
        const _params = {
          database,
          product,
          converter,
          setName,
        };

        setParams(_params);
      }}
    />
  );

  const mainContent = (
    <>
      {name && <div className="tw-text-xl tw-font-bold tw-text-center tw-mb-2">{name}</div>}
      {params && (
        <PageTabs
          key={`${params.database}-${params.product}-${params.converter}`}
          options={[
            { value: 'details', label: 'Details' },
            { value: 'summary', label: 'Summary' },
            { value: 'short_term_returns', label: 'Short-Term Returns' },
            { value: 'long_term_returns', label: 'Long-Term Returns' },
            { value: 'calendar_year_returns', label: 'Calendar Year Returns' },
            { value: 'risk_metrics', label: 'Risk Metrics' },
          ]}
          style={{ width: '200px' }}
          session={session}
        >
          <TabPane tabId="details" role="tabpanel">
            <Details {...params} />
          </TabPane>
          <TabPane tabId="summary" role="tabpanel">
            <Summary {...params} />
          </TabPane>
          <TabPane tabId="short_term_returns" role="tabpanel">
            <ShortTermReturns {...params} />
          </TabPane>
          <TabPane tabId="long_term_returns" role="tabpanel">
            <LongTermReturns {...params} />
          </TabPane>
          <TabPane tabId="calendar_year_returns" role="tabpanel">
            <CalendarYearReturns {...params} />
          </TabPane>
          <TabPane tabId="risk_metrics" role="tabpanel">
            <RiskMetrics {...params} />
          </TabPane>
        </PageTabs>
      )}
    </>
  );

  return <ToggleContainer sideMenu={sideMenu} mainContent={params && mainContent} />;
}

export default QuickView;
